import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../components/Loading';
import { useGetDiceRoundBetsQuery } from '../services/dice/diceServices';

const LudoDisplayGamesPage = () => {
  const navigate = useNavigate();
  const { gameName } = useParams();
  const [page, setPage] = useState(1);

  const { data: roundsData, isLoading, error } = useGetDiceRoundBetsQuery({ page, limit: 20 }, { pollingInterval: 5000, skipPollingIfUnfocused: true, refetchOnFocus: true });

  const total = roundsData?.summary?.overallPL || 0;
  const rounds = roundsData?.data || [];
  const totalPages = roundsData?.pagination?.totalPages || 1;

  return (
    <div className="w-full">
      <div className="flex justify-center">
        <div className="w-full max-w-6xl px-2">
          <div className="bg-white rounded shadow border border-gray-200">
            <div className="bg-[#3e525f] px-5 py-3 flex items-center justify-between">
              <span className="text-xl text-white font-normal">
                {decodeURIComponent(gameName || 'Ludo')}
              </span>
              <button onClick={() => navigate(-1)} className="bg-white text-gray-700 px-4 py-1.5 hover:bg-gray-100 transition-colors">
                Back
              </button>
            </div>

            <div className="bg-gray-50 px-5 py-4 border-b border-gray-200">
              <div className="text-sm text-gray-600 mb-1">Total</div>
              <div className={`text-3xl font-semibold ${total >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                {Number(total).toFixed(2)}
              </div>
            </div>

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="flex justify-center py-8"><Loading /></div>
              ) : error ? (
                <div className="p-4 text-red-500 text-center">{error?.message || 'Error loading data'}</div>
              ) : (
                <table className="w-full border-collapse text-sm">
                  <thead>
                    <tr className="bg-[#3e525f] text-white">
                      <th className="py-3 px-4 text-left font-medium border-r border-gray-600">#</th>
                      <th className="py-3 px-4 text-left font-medium border-r border-gray-600">Round ID</th>
                      <th className="py-3 px-4 text-left font-medium border-r border-gray-600">Open Date</th>
                      <th className="py-3 px-4 text-left font-medium border-r border-gray-600">Winner</th>
                      <th className="py-3 px-4 text-left font-medium border-r border-gray-600">P/L</th>
                      <th className="py-3 px-4 text-left font-medium">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {rounds.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="p-8 text-center text-gray-400 border-t border-gray-200">No data</td>
                      </tr>
                    ) : (
                      rounds.map((round, index) => (
                        <tr key={round.roundId} className="hover:bg-gray-50 border-t border-gray-200">
                          <td className="py-3 px-4 text-gray-800 border-r border-gray-200">{(page - 1) * 20 + index + 1}</td>
                          <td className="py-3 px-4 text-gray-800 border-r border-gray-200">{round.roundId}</td>
                          <td className="py-3 px-4 text-gray-800 border-r border-gray-200">
                            {round.openDate ? new Date(round.openDate).toLocaleString('en-GB', {
                              year: 'numeric', month: '2-digit', day: '2-digit',
                              hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                            }) : '-'}
                          </td>
                          <td className="py-3 px-4 text-gray-800 border-r border-gray-200">{round.winner || '-'}</td>
                          <td className="py-3 px-4 border-r border-gray-200">
                            <span className={`font-semibold ${(round.pl || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                              {(round.pl || 0).toFixed(2)}
                            </span>
                          </td>
                          <td className="py-3 px-4">
                            <button
                              onClick={() => navigate(`/ludo/all-bets/${round.roundId}`)}
                              className="bg-[#3e525f] text-white px-4 py-1.5 text-sm hover:bg-[#2d3f4a] transition-colors"
                            >
                              Show Bets
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {totalPages > 1 && (
              <div className="flex justify-end gap-1 px-4 py-3 border-t border-gray-200">
                <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="px-3 py-1 border border-gray-300 text-sm disabled:opacity-40">‹</button>
                <span className="px-3 py-1 bg-[#3e525f] text-white text-sm">{page} / {totalPages}</span>
                <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} className="px-3 py-1 border border-gray-300 text-sm disabled:opacity-40">›</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LudoDisplayGamesPage;
